import React from 'react';
import Field from 'containers/Field';

const renderFields = (group) => {
  const hasFields = group.fields && group.fields.length > 0;

  if (hasFields) {
    return group.fields.map((fieldName) => (
      <Field key={fieldName} fieldName={fieldName} groupName={group.name} />
    ));
  }

  return null;
};

export default renderFields;
